import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const ConfigContext = createContext({ affiliateUrl: null });

export const ConfigProvider = ({ children }) => {
  const [affiliateUrl, setAffiliateUrl] = useState(null);

  useEffect(() => {
    api.get("/config").then((r) => setAffiliateUrl(r.data.affiliate_url)).catch(() => {});
  }, []);

  return <ConfigContext.Provider value={{ affiliateUrl }}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => useContext(ConfigContext);
